export default {
    'loading.show': 'loading.show',
    'loading.hide': 'loading.hide',
    'AlertDialog.show': 'AlertDialog.show',
    'ConfirmDialog.show': 'ConfirmDialog.show',
    'tab.refresh': 'tab.refresh'
}



// WEBPACK FOOTER //
// ./src/config/custom_events.js